import { AfterViewInit, Component, OnChanges, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Customer } from 'src/app/models/customer';
import { PsychometricEvaluationResponse } from 'src/app/models/response/psychometric-evaluation-response';
import { ParamsService } from 'src/app/services/params.service';
import { PsychometricEvaluationService } from 'src/app/services/psychometric-evaluation.service';

@Component({
  selector: 'app-pos-psychometric-evaluation-modal',
  templateUrl: './pos-psychometric-evaluation-modal.component.html',
  styleUrls: ['./pos-psychometric-evaluation-modal.component.sass']
})
export class PosPsychometricEvaluationModalComponent implements OnInit {

  constructor(public bsModalRef: BsModalRef, private paramService: ParamsService, private psychometricEvaluationService: PsychometricEvaluationService) { }
  customer: Customer = new Customer();
  status: PsychometricEvaluationResponse = new PsychometricEvaluationResponse();
  action: () => any = () => { };

  qrValue: string = "";
  ngOnInit(): void {

  }

  cancel() {
    this.bsModalRef.hide();
  }

  confirm() {
    this.action();
    this.bsModalRef.hide();
  }

  async refresh() {
    this.status = (await this.psychometricEvaluationService.readEvaluationStatus(this.customer.code).toPromise()).response;
  }

  async loadQrCode() {
    if (this.customer && this.customer.code) {
      const testUrl = (await this.psychometricEvaluationService.readToken(this.customer.code).toPromise()).response;
      this.qrValue = `data:image/png;base64,${(await this.psychometricEvaluationService.generateQrCodeImageBase64(testUrl).toPromise()).response}`
    }
  }
}
